var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-drawer',{attrs:{"title":"制品详情","placement":"right","width":"960","closable":false,"visible":_vm.visible},on:{"close":_vm.onClose}},[_c('artifact-version-detail',{attrs:{"version-id":_vm.versionId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }